import { render, staticRenderFns } from "./AssessmentTests.vue?vue&type=template&id=28420b64&scoped=true"
import script from "./AssessmentTests.vue?vue&type=script&lang=ts"
export * from "./AssessmentTests.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentTests.vue?vue&type=style&index=0&id=28420b64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28420b64",
  null
  
)

export default component.exports